"use client";

import * as SeparatorPrimitive from "@radix-ui/react-separator";
import * as React from "react";

import { cn } from "~/lib/utils";

function Separator({ ref: reference, className, orientation = "horizontal", decorative = true, ...props }: { ref?: React.Ref<React.ElementRef<typeof SeparatorPrimitive.Root>> } & React.ComponentPropsWithoutRef<typeof SeparatorPrimitive.Root>) {
	return (
		<SeparatorPrimitive.Root
			className={cn(
				"shrink-0 bg-border",
				orientation === "horizontal" ? "h-[1px] w-full" : "h-full w-[1px]",
				className
			)}
			decorative={decorative}
			orientation={orientation}
			ref={reference}
			{...props}
		/>
	);
}
Separator.displayName = SeparatorPrimitive.Root.displayName;

export { Separator };
